import React from 'react';
export const BonusesSection: React.FC = () => {
  return <section className="bg-white py-20 px-5 text-center" data-id="element-16" data-mp="qdill0nckyrh">
      <div className="inline-block bg-gradient-to-br from-green-brand to-green-light text-white py-[7px] px-[22px] rounded-full text-xs font-sans font-bold tracking-[2px] uppercase mb-[15px]" data-id="element-17" data-mp="gworv9dixy20">
        🎁 4 BONOS ESTRATÉGICOS
      </div>
      <h2 className="text-[clamp(24px,4vw,42px)] text-[#1A1A1A] mb-2.5 leading-[1.2]" data-id="element-18" data-mp="qvw57wk9dsp4">
        Y Además Recibís{' '}
        <em className="text-brown-light not-italic" data-id="element-19" data-mp="zuhl1jycitm7">4 Bonos</em> que
        <br data-id="element-20" data-mp="zu7t3qtqqcdv" />
        Eliminan Cada Obstáculo de tu Obra
      </h2>
      <p className="text-base text-[#777] font-sans mb-[45px] max-w-[600px] mx-auto" data-id="element-21" data-mp="1ejnkn913ilum">
        Siempre incluidos. Sin costo adicional. Diseñados para que no tengas
        excusas para no empezar.
      </p>

      <div className="grid grid-cols-[repeat(auto-fit,minmax(240px,1fr))] gap-5 max-w-[1000px] mx-auto mb-[30px]" data-id="element-22" data-mp="1nl3sb90j09v5">
        {/* Bono 1 */}
        <div className="bg-[#FAFAF5] border border-[#E8E8E0] rounded-2xl py-7 px-[22px] text-left relative transition-all duration-300 hover:border-brown-light hover:shadow-[0_8px_30px_rgba(179,92,55,0.1)] hover:-translate-y-1" data-id="element-23" data-mp="1jgdyrqtcb7de">
          <div className="absolute -top-3 left-[22px] bg-gradient-to-br from-brown-light to-brown-mid text-white w-7 h-7 rounded-full flex items-center justify-center font-black text-[13px] font-sans" data-id="element-24" data-mp="2lvu6m99mdom">
            1
          </div>
          <span className="text-4xl mb-3 block mt-2" data-id="element-25" data-mp="cj0k8x68etap">📅</span>
          <h3 className="text-base text-[#1A1A1A] font-sans font-bold mb-2 leading-[1.3]" data-id="element-26" data-mp="gl5b5o5apbtn">
            Plan 30 Días: De los Vicios a la Disciplina de Obra
          </h3>
          <p className="text-[13px] text-[#666] font-sans leading-[1.6] mb-[15px]" data-id="element-27" data-mp="le6se2sz5nge">
            Tu sargento de obra personal. Qué hacer cada día exacto para que el
            proyecto no muera por procrastinación. Semana a semana, sin
            improvisar.
          </p>
          <div className="flex justify-between items-center" data-id="element-28" data-mp="10a5wl2cyr3g9">
            <span className="text-sm text-brown-light font-sans font-bold line-through opacity-60" data-id="element-29" data-mp="akpf8akxwpe0">
              $7.500
            </span>
            <span className="bg-green-brand text-white py-1 px-3.5 rounded-full text-xs font-sans font-bold" data-id="element-30" data-mp="5npbi6bkbyq2">
              GRATIS
            </span>
          </div>
        </div>

        {/* Bono 2 */}
        <div className="bg-[#FAFAF5] border border-[#E8E8E0] rounded-2xl py-7 px-[22px] text-left relative transition-all duration-300 hover:border-brown-light hover:shadow-[0_8px_30px_rgba(179,92,55,0.1)] hover:-translate-y-1" data-id="element-31" data-mp="fir1f4dnx4tp">
          <div className="absolute -top-3 left-[22px] bg-gradient-to-br from-brown-light to-brown-mid text-white w-7 h-7 rounded-full flex items-center justify-center font-black text-[13px] font-sans" data-id="element-32" data-mp="of018k5jy5gd">
            2
          </div>
          <span className="text-4xl mb-3 block mt-2" data-id="element-33" data-mp="350hkqh5ald1v">📊</span>
          <h3 className="text-base text-[#1A1A1A] font-sans font-bold mb-2 leading-[1.3]" data-id="element-34" data-mp="3534218hzj6xa">
            Eco-Estimator Pro: Calculadora de Materiales
          </h3>
          <p className="text-[13px] text-[#666] font-sans leading-[1.6] mb-[15px]" data-id="element-35" data-mp="1flgq6eixtfl3">
            Excel automatizado. Ingresás los m2 de tu casa y te dice exactamente
            cuánta tierra, arena, paja y cal comprar. Ahorrá hasta 30% en
            logística.
          </p>
          <div className="flex justify-between items-center" data-id="element-36" data-mp="1asnh5egfrl37">
            <span className="text-sm text-brown-light font-sans font-bold line-through opacity-60" data-id="element-37" data-mp="1ar2qw115mob5">
              $5.000
            </span>
            <span className="bg-green-brand text-white py-1 px-3.5 rounded-full text-xs font-sans font-bold" data-id="element-38" data-mp="10waq6oc9zlc5">
              GRATIS
            </span>
          </div>
        </div>

        {/* Bono 3 */}
        <div className="bg-[#FAFAF5] border border-[#E8E8E0] rounded-2xl py-7 px-[22px] text-left relative transition-all duration-300 hover:border-brown-light hover:shadow-[0_8px_30px_rgba(179,92,55,0.1)] hover:-translate-y-1" data-id="element-39" data-mp="rvmbrsiyziyq">
          <div className="absolute -top-3 left-[22px] bg-gradient-to-br from-brown-light to-brown-mid text-white w-7 h-7 rounded-full flex items-center justify-center font-black text-[13px] font-sans" data-id="element-40" data-mp="2m7sxhl9hpi5a">
            3
          </div>
          <span className="text-4xl mb-3 block mt-2" data-id="element-41" data-mp="d5msle9knkiu">⚖️</span>
          <h3 className="text-base text-[#1A1A1A] font-sans font-bold mb-2 leading-[1.3]" data-id="element-42" data-mp="d3tl5wr4ww9s">
            Guía de Permisos y Legalidad Municipal
          </h3>
          <p className="text-[13px] text-[#666] font-sans leading-[1.6] mb-[15px]" data-id="element-43" data-mp="38090ehbv4sj">
            Cómo hablar con el municipio en el "idioma técnico" correcto para
            que aprueben tu proyecto de tierra. Incluye el "hack legal" de la
            Quincha.
          </p>
          <div className="flex justify-between items-center" data-id="element-44" data-mp="3llgc81z79c44">
            <span className="text-sm text-brown-light font-sans font-bold line-through opacity-60" data-id="element-45" data-mp="3ln12hfehe8w6">
              $4.500
            </span>
            <span className="bg-green-brand text-white py-1 px-3.5 rounded-full text-xs font-sans font-bold" data-id="element-46" data-mp="3bnadft8owm3h">
              GRATIS
            </span>
          </div>
        </div>

        {/* Bono 4 */}
        <div className="bg-[#FAFAF5] border border-[#E8E8E0] rounded-2xl py-7 px-[22px] text-left relative transition-all duration-300 hover:border-brown-light hover:shadow-[0_8px_30px_rgba(179,92,55,0.1)] hover:-translate-y-1" data-id="element-47" data-mp="1w42kwg2fgzq8">
          <div className="absolute -top-3 left-[22px] bg-gradient-to-br from-brown-light to-brown-mid text-white w-7 h-7 rounded-full flex items-center justify-center font-black text-[13px] font-sans" data-id="element-48" data-mp="253zf0x7l6qso">
            4
          </div>
          <span className="text-4xl mb-3 block mt-2" data-id="element-49" data-mp="1de3045dme6sm">🌿</span>
          <h3 className="text-base text-[#1A1A1A] font-sans font-bold mb-2 leading-[1.3]" data-id="element-50" data-mp="1hf6j30qysiy2">
            El Manual del Techo Vivo
          </h3>
          <p className="text-[13px] text-[#666] font-sans leading-[1.6] mb-[15px]" data-id="element-51" data-mp="1m89bh5k09mco">
            Cómo construir una cubierta vegetal paso a paso. Tu aire
            acondicionado natural que regula la temperatura y cosecha agua de
            lluvia gratis.
          </p>
          <div className="flex justify-between items-center" data-id="element-52" data-mp="1wzggly06l0zc">
            <span className="text-sm text-brown-light font-sans font-bold line-through opacity-60" data-id="element-53" data-mp="1s26ky0m77t32">
              $3.000
            </span>
            <span className="bg-green-brand text-white py-1 px-3.5 rounded-full text-xs font-sans font-bold" data-id="element-54" data-mp="26q1e1i44bzgo">
              GRATIS
            </span>
          </div>
        </div>
      </div>

      <div className="bg-gradient-to-br from-[#F5F0E8] to-[#FFF8F0] border-2 border-dashed border-brown-light rounded-xl py-5 px-[30px] max-w-[500px] mx-auto flex justify-between items-center flex-wrap gap-2.5 md:flex-col md:text-center" data-id="element-55" data-mp="1e2oqb4m81lls">
        <span className="text-base font-sans font-bold text-[#333]" data-id="element-56" data-mp="1n08v2njam015">
          Valor total de los 4 bonos
        </span>
        <span className="text-[22px] font-black text-brown-light font-sans line-through opacity-60" data-id="element-57" data-mp="2yhh09b1rjk6d">
          $20.000
        </span>
        <span className="text-[22px] font-black text-green-brand font-sans" data-id="element-58" data-mp="2ufdkwbbz3vft">
          → GRATIS con tu Mega Pack
        </span>
      </div>
    </section>;
};